import pager from './pager.vue'
export default pager